<!-- 申请入驻 -->
<template>
  <div>
    <el-form :model="menuForm" :rules="rules" ref="ruleForm" label-width="110px" class="width topp">
      <h1 style="text-align: center;">企业入驻申请</h1>
      <el-form-item label="企业名称" prop="name">
        <el-input v-model="menuForm.name"></el-input>
      </el-form-item>
      <el-form-item label="官网地址">
        <el-input v-model="menuForm.website"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="contacts">
        <el-input v-model="menuForm.contacts"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="menuForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱" prop="conemail">
        <el-input v-model="menuForm.conemail"></el-input>
      </el-form-item>
      <el-form-item label="法定代表人" prop="representative">
        <el-input v-model="menuForm.representative"></el-input>
      </el-form-item>
      <el-form-item label="成立时间" prop="create_time">
        <el-date-picker
          v-model="menuForm.create_time"
          type="date"
          placeholder="选择日期"
          style="width:100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="注册资金" prop="capital">
        <el-input v-model="menuForm.capital"></el-input>
      </el-form-item>
      <el-form-item label="企业类型" prop="pr_type">
        <el-select
          v-model="menuForm.pr_type"
          filterable
          clearable
          placeholder="请选择"
          style="width:100%"
        >
          <el-option v-for="(item ,i) in selectOption" :key="i" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <!-- <el-input v-model="menuForm.pr_type"></el-input> -->
      </el-form-item>
      <el-form-item label="所属行业" prop="industry">
        <el-select
          v-model="menuForm.industry"
          filterable
          clearable
          placeholder="请选择"
          style="width:100%"
        >
          <el-option
            v-for="(item ,i) in selectindustry"
            :key="i"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- <el-input v-model="menuForm.industry"></el-input> -->
      </el-form-item>
      <el-form-item label="企业规模" prop="size">
        <el-select
          v-model="menuForm.size"
          filterable
          clearable
          placeholder="请选择"
          style="width:100%"
        >
          <el-option v-for="(item ,i) in selectcount" :key="i" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <!-- <el-input v-model="menuForm.size"></el-input> -->
      </el-form-item>
      <el-form-item label="业务范围" prop="content">
        <el-input v-model="menuForm.content"></el-input>
      </el-form-item>
      <el-form-item label="企业等级" prop="lever">
        <el-input v-model="menuForm.lever"></el-input>
      </el-form-item>
      <el-form-item label="企业地址" prop="address">
        <v-region :town="true" @values="selectLogs" v-model="selected"></v-region>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="menuForm.address"></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="xiangxi">
        <el-input v-model="menuForm.xiangxi"></el-input>
      </el-form-item>
      <el-form-item label="企业展示图片" prop="cover_logo">
        <input type="file" @change="addFile" ref="inputer" />
      </el-form-item>
      <el-form-item label="身份证正面" prop="shenfenz">
        <input type="file" @change="addFile1" ref="inputer1" />
      </el-form-item>
      <el-form-item label="身份证反面" prop="shenfenf">
        <input type="file" @change="addFile2" ref="inputer2" />
      </el-form-item>
      <el-form-item label="营业执照" prop="yinye">
        <input type="file" @change="addFile3" ref="inputer3" />
      </el-form-item>
      <el-form-item required label="资质证书" v-for="(item,i) in this.menuForm.quadata" :key="i">
        <el-col :span="5" style="padding-right:5px">
          <el-form-item>
            <el-input v-model="menuForm.quadata[i].type" placeholder="证书类型"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" style="padding-right:5px">
          <el-form-item>
            <el-input v-model="menuForm.quadata[i].name" placeholder="证书名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="padding-right:5px">
          <el-form-item>
            <el-input v-model="menuForm.quadata[i].number" placeholder="证书编号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="padding-right:5px">
          <el-form-item>
            <el-date-picker
              type="date"
              placeholder="发证时间"
              v-model="menuForm.quadata[i].create_time"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>

          <!-- <el-input v-model="menuForm.quadata[i].create_time" placeholder="发证时间"></el-input> -->
        </el-col>
        <el-col :span="4" style="padding-right:5px">
          <el-form-item>
            <el-date-picker
              type="date"
              placeholder="证书截止时间"
              v-model="menuForm.quadata[i].end_time"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>

          <!-- <el-input v-model="menuForm.quadata[i].end_time" placeholder="证书截止时间"></el-input> -->
        </el-col>
        <el-col :span="2" v-show="i==0">
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="addCapdata(1)"
            style="width:100%"
          >新增</el-button>
        </el-col>
        <el-col :span="2" v-show="i!=0">
          <el-button icon="el-icon-circle-close" @click="deleteCapdata(i,1)" style="width:100%">删除</el-button>
        </el-col>
      </el-form-item>
      <div>
        <el-form-item required label="软件著作权" v-for="(item1,k) in this.menuForm.copdata" :key="k">
          <el-col :span="4" style="padding-right:5px">
            <el-form-item>
              <el-input v-model="menuForm.copdata[k].lever" placeholder="版本号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="padding-right:5px">
            <el-form-item>
              <el-input v-model="menuForm.copdata[k].name" placeholder="著作权名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="padding-right:5px">
            <el-form-item>
              <el-input v-model="menuForm.copdata[k].abbreviation" placeholder="软件简称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="padding-right:5px">
            <el-form-item>
              <el-date-picker
                type="date"
                placeholder="发布时间"
                v-model="menuForm.copdata[k].create_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

            <!-- <el-input v-model="menuForm.copdata[k].create_time" placeholder="发布时间"></el-input> -->
          </el-col>
          <el-col :span="3" style="padding-right:5px">
            <el-form-item>
              <el-input v-model="menuForm.copdata[k].regnumber" placeholder="登记号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="padding-right:5px">
            <el-form-item>
              <el-date-picker
                type="date"
                placeholder="批准登记日期"
                v-model="menuForm.copdata[k].regtime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

            <!-- <el-input v-model="menuForm.copdata[k].regtime" placeholder="批准登记日期"></el-input> -->
          </el-col>
          <el-col :span="2" v-show="k==0">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="addCapdata(2)"
              style="width:100%"
            >新增</el-button>
          </el-col>
          <el-col :span="3" v-show="k!=0">
            <el-button icon="el-icon-circle-close" @click="deleteCapdata(k,2)" style="width:100%">删除</el-button>
          </el-col>
        </el-form-item>
      </div>

      <el-form-item style="text-align: center;">
        <el-button @click="men">取 消</el-button>
        <el-button type="primary" @click="menuBtn('ruleForm')">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    var checkPhone = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/

        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }

    return {
      menuForm: {
        quadata: [
          {
            type: '',
            name: '',
            number: '',
            create_time: '',
            end_time: '',
          },
        ],
        copdata: [
          {
            lever: '',
            name: '',
            abbreviation: '',
            create_time: '',
            regnumber: '',
            regtime: '',
          },
        ],
      },
      file: {}, //文件数据
      imgFile: {},
      formData: new FormData(),
      file1: {}, //文件数据
      imgFile1: {},
      formData1: new FormData(),
      file2: {}, //文件数据
      imgFile2: {},
      formData2: new FormData(),
      file3: {}, //文件数据
      imgFile3: {},
      formData3: new FormData(),
      selected: {
        province: '350000',
        city: '350100',
        area: '350104',
        town: '350104008',
      },
      rules: {
        name: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机' },
          { validator: checkPhone, trigger: 'blur' },
        ],
        conemail: [
          { required: true, message: '请输入邮箱' },
          { validator: checkEmail, trigger: 'blur' },
        ],
        contacts: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        representative: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        create_time: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        capital: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        pr_type: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        industry: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        size: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        lever: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        selected: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        address: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        xiangxi: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        copdataLevel: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        copdataName: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        abbreviation: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        copdataCreate: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        regnumber: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        regtime: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        quadataType: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        quadataName: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        quadataNumber: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        quadataCreate: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        quadataEnd: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
      },
      selectOption: [],
      selectcount: [],
      selectindustry: [],
    }
  },
  computed: {},
  watch: {},
  created() {
    this.allindustry()
    this.allprcount()
    this.allindustrys()
  },
  mounted() {},
  methods: {
    // 获取企业类型
    async allindustry() {
      const res = await this.$http.post('/allprtype') // eslint-disable-line no-unused-vars
      this.selectOption = res.data.data
    },
    // 获取企业规模
    async allprcount() {
      const res = await this.$http.post('/allprcount') // eslint-disable-line no-unused-vars
      this.selectcount = res.data.data
    },
    // 获取企业所属行业
    async allindustrys() {
      const res = await this.$http.post('/allindustry') // eslint-disable-line no-unused-vars
      this.selectindustry = res.data.data
    },
    addCapdata(i) {
      if (i == 1) {
        this.menuForm.quadata.push({
          type: '',
          name: '',
          number: '',
          create_time: '',
          end_time: '',
        })
      } else {
        this.menuForm.copdata.push({
          lever: '',
          name: '',
          abbreviation: '',
          create_time: '',
          regnumber: '',
          regtime: '',
        })
      }
    },
    deleteCapdata(i, j) {
      if (j == 1) {
        this.menuForm.quadata.splice(i, 1)
      } else {
        this.menuForm.copdata.splice(i, 1)
      }
    },
    // 上传图片
    addFile: function () {
      // console.log(this.editForm.file)

      var _this = this
      let inputDOM = this.$refs.inputer
      // let oldLen = this.filLen;
      this.file = inputDOM.files[0]
      let len = this.file.length
      let size = Math.floor(this.file.size / 1024)
      if (size > 20 * 1024 * 1024) {
        alert('请选择20M以内的图片！')
        return false
      }
      this.formData.append('file', this.file)

      this.$http({
        method: 'post',
        url: '/uploadsupimg',
        data: this.formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(function (res) {
          // console.log(res)
          _this.menuForm.cover_logo = res.data.url
        })
        .catch(function (err) {
          // console.log('新建分享', err)
        })
    },
    addFile1: function () {
      // console.log(this.editForm.file)

      var _this = this
      let inputDOM = this.$refs.inputer1
      // let oldLen = this.filLen;
      this.file1 = inputDOM.files[0]
      let len = this.file1.length
      let size = Math.floor(this.file1.size / 1024)
      if (size > 20 * 1024 * 1024) {
        alert('请选择20M以内的图片！')
        return false
      }
      this.formData1.append('file', this.file1)

      this.$http({
        method: 'post',
        url: '/uploadsupimg',
        data: this.formData1,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(function (res) {
          _this.menuForm.shenfenz = res.data.url
        })
        .catch(function (err) {
          // console.log('新建分享', err)
        })
    },
    addFile2: function () {
      // console.log(this.editForm.file)

      var _this = this
      let inputDOM = this.$refs.inputer2
      // let oldLen = this.filLen;
      this.file2 = inputDOM.files[0]
      let len = this.file2.length
      let size = Math.floor(this.file2.size / 1024)
      if (size > 20 * 1024 * 1024) {
        alert('请选择20M以内的图片！')
        return false
      }
      this.formData2.append('file', this.file2)

      this.$http({
        method: 'post',
        url: '/uploadsupimg',
        data: this.formData2,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(function (res) {
          _this.menuForm.shenfenf = res.data.url
        })
        .catch(function (err) {
          // console.log('新建分享', err)
        })
    },
    addFile3: function () {
      // console.log(this.editForm.file)

      var _this = this
      let inputDOM = this.$refs.inputer3
      // let oldLen = this.filLen;
      this.file3 = inputDOM.files[0]
      let len = this.file3.length
      let size = Math.floor(this.file3.size / 1024)
      if (size > 20 * 1024 * 1024) {
        alert('请选择20M以内的图片！')
        return false
      }
      this.formData3.append('file', this.file3)

      this.$http({
        method: 'post',
        url: '/uploadsupimg',
        data: this.formData3,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(function (res) {
          _this.menuForm.yinye = res.data.url
        })
        .catch(function (err) {
          // console.log('新建分享', err)
        })
    },
    selectLogs(data) {
      if (data.town) {
        this.menuForm.province = data.province.key
        this.menuForm.town = data.town.key
        this.menuForm.area = data.area.key
        this.menuForm.city = data.city.key
        this.menuForm.address =
          data.province.value +
          data.city.value +
          data.area.value +
          data.town.value
      }
    },
    async menuBtn(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (sessionStorage.getItem('codes')) {
            this.menuForm.codes = sessionStorage.getItem('codes')
          }
          if (
            this.menuForm.cover_logo != '' &&
            this.menuForm.shenfenz != '' &&
            this.menuForm.shenfenf != '' &&
            this.menuForm.yinye != ''
          ) {
            const res = await this.$http.post('/settledsup', this.menuForm) // eslint-disable-line no-unused-vars
            if (res.data.code == '0000') {
              this.$router.push('/home')
              this.$message({
                type: 'success',
                message: res.data.message,
              })
            } else {
              this.$message({
                type: 'warning',
                message: res.data.message,
              })
            }
          } else {
            this.$message({
              type: 'warning',
              message: '请上传图片',
            })
          }
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    men() {
      this.$router.push('/home')
    },
  },
}
</script>

<style  lang="less">
.topp {
  padding: 5px 20px 20px 20px;
  background-color: #fff;
  margin-top: 10px;
}
div.rg-select div.rg-select__el div.rg-select__content {
  padding: 0 30px 0 15px;
  background-color: #fff;
}
</style>
